import { __assign } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import Lozenge from '@atlaskit/lozenge';
import { Frame } from '../components/Frame';
import { Thumbnail } from '../components/Thumbnail';
import { Provider } from '../components/Provider';
import { Name } from '../components/Name';
import { Byline } from '../components/Byline';
import { ActionList } from '../components/ActionList';
import { CollaboratorList } from '../components/CollaboratorList';
import { Icon } from '../components/Icon';
import { Content } from '../components/Content';
import { containerCentredStyles } from '../utils/constants';
import { MetadataList } from '../components/MetadataList';
import { LozengeWrapper } from '../../InlineCard/IconAndTitleLayout/styled';
export var ResolvedView = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? {} : _b, _c = _a.actions, actions = _c === void 0 ? [] : _c, thumbnail = _a.thumbnail, _d = _a.context, context = _d === void 0 ? { text: '' } : _d, _e = _a.title, title = _e === void 0 ? '' : _e, _f = _a.isSelected, isSelected = _f === void 0 ? false : _f, _g = _a.description, description = _g === void 0 ? '' : _g, _h = _a.users, users = _h === void 0 ? [] : _h, _j = _a.handleAvatarClick, handleAvatarClick = _j === void 0 ? function () { } : _j, _k = _a.handleMoreAvatarsClick, handleMoreAvatarsClick = _k === void 0 ? function () { } : _k, _l = _a.onClick, onClick = _l === void 0 ? function () { } : _l, link = _a.link, byline = _a.byline, lozenge = _a.lozenge, _m = _a.details, details = _m === void 0 ? [] : _m, testId = _a.testId;
    var resolvedMetadata = details.length && (jsx(MetadataList, { testId: testId ? testId + "-meta" : undefined, items: details }));
    var resolvedByline = byline ? (jsx(Byline, { testId: testId ? testId + "-by" : undefined }, byline)) : (jsx(Byline, { testId: testId ? testId + "-by" : undefined, text: description }));
    return (jsx(Frame, { isSelected: isSelected, testId: testId },
        jsx(Content, null,
            jsx("div", null,
                jsx("div", { css: containerCentredStyles },
                    jsx("a", { onClick: onClick, href: link, target: "_blank", css: { display: 'flex', alignItems: 'center' } },
                        jsx(Icon, __assign({}, icon)),
                        jsx(Name, { name: title }),
                        lozenge && (jsx(LozengeWrapper, null,
                            jsx(Lozenge, __assign({}, lozenge), lozenge.text)))),
                    jsx(CollaboratorList, { items: users, handleAvatarClick: handleAvatarClick, handleMoreAvatarsClick: handleMoreAvatarsClick })),
                resolvedMetadata || resolvedByline),
            jsx("div", { css: containerCentredStyles },
                jsx(Provider, { name: context.text, iconUrl: context.icon }),
                jsx(ActionList, { items: actions }))),
        thumbnail ? (jsx(Thumbnail, { src: thumbnail, testId: testId ? testId + "-thumb" : undefined })) : null));
};
//# sourceMappingURL=ResolvedView.js.map